import { Permission, UserPermissions } from "models/permissions.model";
const config = useRuntimeConfig();

export const permissions = {
  useGetAllUsersPermissions: createUseApi<
    {
      page: number;
      limit: number;
    },
    UserPermissions
  >({
    method: "GET",
    url: `${config.public.url}/permission/user`,
    queryBuilder: (input) => {
      return input;
    },
    requireAuthentication: true,
  }),

  useGetAllPermissions: createUseApi<void, Permission[]>({
    method: "GET",
    url: `${config.public.url}/permission`,
    requireAuthentication: true,
  }),
  useCreateUserPermission: createUseApi<
    { userEmail: string; name: string },
    void
  >({
    method: "POST",
    url: `${config.public.url}/permission/user`,
    dataBuilder: (input) => {
      return input;
    },
    requireAuthentication: true,
  }),

  useDeleteUserPermission: createUseApi<
    { userEmail: string; name: string },
    void
  >({
    method: "DELETE",
    url: `${config.public.url}/permission/user`,
    dataBuilder: (input) => {
      return input;
    },
    requireAuthentication: true,
  }),
};
